<template>
    <div class="mainCon">
      <div class="scene-Header">
        <div class="mainDivWidth flexDiv">
          <p class="sceneTitle">智慧加油API对接说明</p>
          <div class="bussinbtn" @click="goBusiness()">立即对接</div>
        </div>
      </div>
      <div class="box-shadow">
        <div class="mainDivWidth flexDiv anchorNavList" id="anchorNavList">
          <p v-for="(nl,index) in navList" :key="index" :class=" anchorId == index ? 'nowAnchor' : '' " @click="changeanchorId(index, nl.id)">
            {{nl.text}}
          </p>
        </div>
      </div>
      <section class="mainFun" id="mainFun">
        <div class="mainDivWidth flexDiv feaTure">
          <div class="introduceTextImg">
            <img
              src="static/img/docdescription/mainpic.png"
              class="introduceImg"
            />
            <p>智慧加油API<br>对接说明</p>
          </div>
          <div class="first-introduceText">
            <div class="introduceText-Title flexDiv">
              <p class="titleBg">主要功能</p>
              <p class="subheading">MAJOR FUNCTION</p>
            </div>
            <div class="cer-FunCon">
              <p>
                一站式汽车加油解决方案，为渠道解决了线上加油问题，用户在加油站、车内下单并支付成功，经加油站设备播报后即可离开加油站，全程车内操作，同时还可参与多方渠道（银行、运营商、保险等）开展的优惠活动。拒绝排队，获取实惠，体验移动互联网带来的全新加油体验。
              </p>
            </div>
          </div>
        </div>
      </section>
      <section id="joinFlow" class="payforCont">
        <div class="mainDivWidth">
          <h3 class="sectionTitle whiteText">接入流程</h3>
          <div class="joinCont flexDiv">
            <div class="joinflow"  v-for="(joflow, index) in joinflowList" :key="index">
              <img :src="joflow.joflow" alt="">
              <p v-text="joflow.jointxt"></p>
            </div>
          </div>
        </div>
      </section>
      <section id="conadvantage" class="conadvantage">
        <div class="mainDivWidth">
          <h3 class="sectionTitle whiteText">接入优势</h3>
          <div class="connetadv flexDiv">
            <div class="conadvTxt">
              <p>去加油平台为企业提供可接入式的加油站场景支付优化模块，为企业自有产品或运营平台增加满足刚性需求的功能模块。增加企业自有产品用户的活跃率和忠诚度。同时免除线下维护成本、功能开发成本、服务器成本、活动补贴成本等多方面支出。</p>
              <p>企业接入去加油，相当于同时拥有了一套完善的加油站场景支付系统、上百人的运维团队、上千家线下加油站商户、诱人的多方渠道活动资源。丰富企业产品功能、节约企业成本、提升企业品牌形象、建立用户对企业的信任度和忠诚度。</p>
            </div>
            <div class="advmain">
              <div class="advmaincont" v-for="(spl, index) in sellingPointList" :key="index">
                <img :src="spl.pic" alt="">
                <p v-text="spl.title"></p>
              </div>
            </div> 
          </div>
        </div>
      </section>
      <section class="modelFun" id="modelFun">
        <h3 class="sectionTitle">对接模块</h3>
        <div class="flexDiv mainDivWidth modelFuncont">
          <div class="modelmain"  v-for="(mod, index) in modelfunList" :key="index">
            <img :src="mod.pics" alt="">
            <p v-text="mod.title"></p>
          </div>
        </div>
      </section>
      <section class="Dloadfile" id="Dloadfile">
        <h3 class="sectionTitle whiteText">下载接入</h3>
        <div class="Downloadfile">
          <div class="downCont whiteText">
            <span>下载智慧加油API对接文档，快速对接体验</span> 
            <div class="downtxt" @click="handleDownload">
              <img src="static/img/docdescription/downloadicon.png" alt="">
              <div class="downfiletxt">立即下载</div>
            </div>
            <p class="comfirtxt">该文档仅供测试参考，申请参数请联系官网微信/QQ</p>
          </div>
        </div>
      </section>
    </div>
  </template>
  
  <script>
  export default {
    name: 'dockFuelAPI',
    data:function(){
      return {
        anchorId: 0,
        navList: [
          {text: '主要功能', id: 'mainFun'},
          {text: '接入流程', id: 'joinFlow'},
          {text: '接入优势', id: 'conadvantage'},
          {text: '对接模块', id: 'modelFun'},
          {text: '下载接入', id: 'Dloadfile'},
        ],
        sellingPointList:[
          {
            title: '方便用户提升加油效率', pic:"static/img/docdescription/fuelApi/numicon/numicon01.png"
            },
          {
            title: '提升加油站员工效率,节约成本', pic:"static/img/docdescription/fuelApi/numicon/numicon02.png"
          },
          {
            title: 'To C 带来用户及补贴带动交易量', pic:"static/img/docdescription/fuelApi/numicon/numicon03.png"
          },
          {
            title: '数据共享提升营销效率',pic:"static/img/docdescription/fuelApi/numicon/numicon04.png"
          },
          {
            title:"ToB规范化管理和用户和交易量增长",
            pic:"static/img/docdescription/fuelApi/numicon/numicon05.png"
          }
        ],
        modelfunList:[
          {
            pics:"static/img/docdescription/fuelApi/modelicon/modlicon01.png",
            title:"智慧加油前端"
          },
          {
            pics:"static/img/docdescription/modelfun/modelicon/icon02.png",
            title:"佰付美平台登录"
          },
          {
            pics:"static/img/docdescription/fuelApi/modelicon/modlicon03.png",
            title:"佰付美平台支付"
          },
          {
            pics:"static/img/docdescription/modelfun/modelicon/icon04.png",
            title:"佰付美平台活动配置"
          },
          {
            pics:"static/img/docdescription/modelfun/modelicon/icon05.png",
            title:"佰付美平台营销配置"
          }
        ],
        joinflowList:[
          {
            joflow:"static/img/docdescription/fuelApi/flowicon/flowicon01.png",
            jointxt:"配置渠道地址"
          },
          {
            joflow:"static/img/docdescription/fuelApi/flowicon/flowicon02.png",
            jointxt:"基于单渠道需求进行二次开发"
          },
          {
            joflow:"static/img/docdescription/fuelApi/flowicon/flowicon03.png",
            jointxt:"明确支付方式（自有支付 /第三方支付接入）"
          },
          {
            joflow:"static/img/docdescription/fuelApi/flowicon/flowicon04.png",
            jointxt:"配置渠道活动"
          },
          {
            joflow:"static/img/docdescription/fuelApi/flowicon/flowicon05.png",
            jointxt:"渠道测试"
          },
          {
            joflow:"static/img/docdescription/fuelApi/flowicon/flowicon06.png",
            jointxt:"上线"
          },
          {
            joflow:"static/img/docdescription/fuelApi/flowicon/flowicon07.png",
            jointxt:"渠道推广、活动推广"
          }
        ]
      }
    },
    mounted() {
    },
    methods:{
      // 立即下载
      handleDownload(){
        let a = document.createElement('a')
        a.href ="https://cdn.epaynfc.com/Activities/2006June/other/downloadfile/去加油API.pdf"
        a.click();
      },
      goBusiness(){
        this.$router.push({"path": "/cooperate"})
      },
      changeanchorId(num, id){
        this.anchorId = num;
        $('html, body').animate({scrollTop: $('#'+ id).offset().top }, 1000);
        return false;// 返回false可以避免在原链接后加上#
      },
    }
  }
  </script>
  
  <style scoped lang="scss">
    @import "../../assets/css/descriptionClass/docStyle";
    @import "../../assets/css/descriptionClass/fuelsty";
  </style>
  


// WEBPACK FOOTER //
// src/pages/dockingConPage/document4-fuelApi.vue